import { render, staticRenderFns } from "./number_field_table.vue?vue&type=template&id=b8fa8ad8&"
import script from "./number_field_table.vue?vue&type=script&lang=js&"
export * from "./number_field_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports